import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import BBALoader from './BBALoader';

const AuthLoadingIndicator = () => {
  const { loading, loadingTimeout } = useAuth();

  if (!loading) return null;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <BBALoader size={128} className="mb-8" />
      
      {loadingTimeout && (
        <div className="text-center max-w-md mx-auto px-4">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Authentication is taking longer than usual
          </h2>
          <p className="text-gray-600 mb-4">
            This might be due to network issues or server load. Please wait a moment longer.
          </p>
          <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
            <p className="text-sm text-yellow-800">
              If this continues for more than 10 seconds, you'll be redirected to the login page.
            </p>
          </div>
        </div>
      )}
      
      {!loadingTimeout && (
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            Loading...
          </h2>
          <p className="text-gray-600">
            Please wait while we authenticate your session.
          </p>
        </div>
      )}
    </div>
  );
};

export default AuthLoadingIndicator;
